module.exports = __webpack_public_path__ + "img/hotzapp.93cf5039.svg";